import posthog from 'posthog-js';

import { dropNoiseEvents } from '@/lib/posthog-noise';

const token = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN;

if (token) {
  posthog.init(token, {
    api_host: '/ingest',
    ui_host: 'https://us.posthog.com',
    defaults: '2026-01-30',
    capture_exceptions: true,
    cross_subdomain_cookie: true,
    debug: process.env.NODE_ENV === 'development',
    before_send: dropNoiseEvents,
  });
  // FLO-797: project 406762 also receives flowtnow.com events. Stamping every
  // event lets the app and the marketing site be filtered apart.
  posthog.register({ site: 'app' });
}
